// extracted by mini-css-extract-plugin
export default {"searchInput":"styles_searchInput__OPHOR","input":"styles_input__opbH4","btn":"styles_btn__4y8CF"};